/**
 * 收录台账 API — F5（契约见 kickoff 02 §4）。
 *
 * 本批（批 3 包 B）仅接入 summary 漏斗端点供情报总览使用；
 * 端点属批 5 交付，可能未就绪——调用方必须自行 try/catch 做优雅降级（空态展示）。
 *
 * GET /api/index-ledger/summary?product_id= →
 *   {produced, indexed, ai_retrievable, index_rate, retrieval_rate, status_counts, baseline_index_rate}
 */
import client from "./client";
import type {
  LedgerSummary,
  LedgerUrlItem,
  LedgerUrlImportResult,
  PaginatedData,
} from "../types";

/** 获取三层漏斗聚合（product_id 必填）。 */
export async function getIndexLedgerSummary(
  productId: string,
): Promise<LedgerSummary> {
  return client.get<unknown, LedgerSummary>("/index-ledger/summary", {
    params: { product_id: productId },
  });
}

/** URL 池列表查询参数（product_id 必填）。 */
export interface IndexLedgerParams {
  product_id: string;
  status?: string; // pending/indexed/abnormal/resolved/demoted
  channel?: string;
  page?: number;
  size?: number;
}

/** 获取 URL 池列表。 */
export async function getIndexLedger(
  params: IndexLedgerParams,
): Promise<PaginatedData<LedgerUrlItem>> {
  return client.get<unknown, PaginatedData<LedgerUrlItem>>("/index-ledger", {
    params,
  });
}

/**
 * 手工录入 URL（轻量写 LR1，运营方权限）。
 * 服务端做 url 归一化 + sha256 去重，重复跳过；返回 created/duplicated/failed 三类清单。
 */
export async function postIndexLedgerUrls(body: {
  product_id: string;
  urls: { url: string; title?: string; channel: string }[];
}): Promise<LedgerUrlImportResult> {
  return client.post<unknown, LedgerUrlImportResult>("/index-ledger/urls", body);
}
